import type { CurrencyISO } from '@/constants/currencies';
import { getTradingItemCurrencyISO } from '@/utilities/getTradingItemCurrencyISO';
import { useExistingNarrative } from '@/hooks/narrative/useExistingNarrative';
import {
  DeferRender,
  MiniPriceChartDefinitions,
  DeprecatedNarrativeMiniPriceChart,
} from '@components/MiniPriceChart';
import MiniPriceChart from '@components/MiniPriceChart';
import useUser from '@/hooks/useUser';

type Props = {
  companyId: string;
};

export const NarrativeKeyMetricChart = ({ companyId }: Props) => {
  const { data: user } = useUser();
  const { data: existingNarrative, status } = useExistingNarrative({
    companyId,
    loggedIn: user.loggedIn,
  });

  if (status === 'pending' || status === 'error') {
    return <div>{/* Placeholder div to prevent CLS */}</div>;
  }

  const currencyISO = getTradingItemCurrencyISO(
    existingNarrative.Company.data.currencyInfo
  );
  const { myValuation } = existingNarrative.Company ?? {};

  if (!user.loggedIn) {
    return (
      <div
        data-cy-id="key-metric-value-1Y-Price-Chart"
        className="col-span-2 lg:mr-x3"
      >
        <MiniPriceChartDefinitions />
        <DeferRender>
          <MiniPriceChart
            companyId={companyId}
            period="1Y"
            align="left"
            currencyISO={currencyISO as CurrencyISO}
          />
        </DeferRender>
      </div>
    );
  }

  return (
    <div
      data-cy-id="key-metric-value-1Y-Price-Chart"
      className="col-span-1 lg:mr-x3"
    >
      <MiniPriceChartDefinitions />
      <DeferRender>
        <DeprecatedNarrativeMiniPriceChart
          companyId={companyId}
          period="1Y"
          align="left"
          currencyISO={currencyISO as CurrencyISO}
          fairValue={myValuation?.fairValue ?? null}
        />
      </DeferRender>
    </div>
  );
};
